import { lazy } from "react";
import Loadable from "ui-component/Loadable";
import { Navigate } from "react-router-dom";
import AuthWrapper from "components/AuthWrapper";

const AuthLogin = Loadable(lazy(() => import("views/pages/authentication/auth-forms/AuthLogin.js")));
const AuthenticationRoutes = {
  path: "/auth",
  children: [
    {
      path: "", // /auth par jane par
      element: <Navigate to="/auth/login" replace />
    },
    {
      path: "login",
      element: <AuthWrapper><AuthLogin /></AuthWrapper>,
    },
  ],
};

export default AuthenticationRoutes;